"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSnippetStyles = void 0;
const lit_1 = require("lit");
exports.userSnippetStyles = (0, lit_1.css) `
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    position: relative;
  }

  .detail {
    display: flex;
    flex-direction: column;
  }

  mm-accent-tag {
    position: absolute;
    left: var(--space-1-minus);
    top: var(--space-1-minus);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1zbmlwcGV0LnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZXItc25pcHBldC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXlCO0FBRVosUUFBQSxpQkFBaUIsR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBa0JuQyxDQUFBIn0=